<template>
  <p class="form-error" v-html="errorMessage" />
</template>

<script>
  export default {
    name: 'FormError',
    props: {
      errorMessage: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .form-error {
    color: var(--itr-color-danger);
    font-size: 14px;
    margin: 0;
    padding: 0 8px;
    font-style: italic;
    min-height: 25px;
    width: 100%;
    text-align: right;
  }
</style>
